import React from 'react'
import { Input, Form, Dropdown } from 'semantic-ui-react'

export const MyInput = ({
    field: { name },
    form: { touched, errors, setFieldValue },
    ...props
}) => (
    <>
        <Form.Input
            {...props}
            onChange={(value, data) => setFieldValue(name, data.value == "" ? null : data.value)}
        />
        {/* <Input {...field} {...props} />
            {touched[field.name] && errors[field.name] && <small>{errors[field.name]}</small>} */}
    </>
)
export const MyNumInput = ({
    field: { name },
    form: { touched, errors, setFieldValue },
    ...props
}) => (
    <>
        <Form.Input
            {...props}
            onChange={(value, data) => setFieldValue(name, data.value == "" ? null : +data.value)}
        />
        {/* <Input {...field} {...props} />
            {touched[field.name] && errors[field.name] && <small>{errors[field.name]}</small>} */}
    </>
)

export const numberInput = ({
    field: { name },
    form: { touched, errors, setFieldValue },
    ...props
}) => (
    <>
        <Form.Input
            {...props}
            type="number"
            onChange={(value, data) => setFieldValue(name, data.value == "" ? null : +data.value)}
        />
        {/* <Input {...field} {...props} />
            {touched[field.name] && errors[field.name] && <small>{errors[field.name]}</small>} */}
    </>
)

export const MyTempInput = ({
    field: { name },
    form: { touched, errors, setFieldValue },
    ...props
}) => (
    <>
        <Form.Input
            {...props}
            type="number"
            onChange={(value, data) => setFieldValue(name, data.value == "" ? null : +data.value)}
        />
        {/* <Input {...field} {...props} />
            {touched[field.name] && errors[field.name] && <small>{errors[field.name]}</small>} */}
    </>
)
export const MyNormalInput = ({
    field,
    form: { touched, errors },
    ...props
}) => (
    <>
        <Input
            {...field}
            {...props}
        />
        {/* <Input {...field} {...props} />
                {touched[field.name] && errors[field.name] && <small>{errors[field.name]}</small>} */}
    </>
)

export const MyCheckBox = ({
    field,
    form: { touched, errors },
    ...props
}) => (
    <>
        <Form.Checkbox {...field} {...props} slider />
    </>
)
export const MyNormalCheckBox = ({
    field: { name },
    form: { touched, errors, setFieldValue },
    ...props
}) => (
    <>
        <Form.Checkbox {...props} onChange={(event, data) => setFieldValue(name, data.checked)} />
    </>
)
export const MyTextArea = ({
    field,
    form: { touched, errors },
    ...props
}) => (
    <>
        <Form.TextArea {...field} {...props} />
    </>
)
export const MyDropdown = ({
    field: { name },
    form: { touched, errors, setFieldValue },
    ...props
}) => (
    <>
        <Dropdown
            fluid
            selection
            placeholder={props.placeholder}
            onChange={(value, data) => setFieldValue(name, data.value)}
            {...props}
        />
    </>
)
